import BodyText from "./BodyText";
import PropTypes from "prop-types";
import React from "react";

function ProductAttribute({ attribute: { name, value } }) {
  return (
    <BodyText>
      {name} : {value}
    </BodyText>
  );
}

export default ProductAttribute;

ProductAttribute.propTypes = {
  attribute: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};
